import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const prefixInjectionProps = "inj" // "INJECTION_"

export const targetTypes = {
    item: {
        id: "item",
        key: "",
        description: "Support product, item, category, ...",
        isMain: true
    },
    document: {
        id: "document",
        key: "doc",
        description: "Support document, document_item, ...",
        isMain: true
    },
    documentItem: {
        id: "document_item",
        key: "doci",
        description: "Subset from document",
        isMain: false
    },
    repository: {
        id: "repository",
        key: "",
        description: "Support repository, package, repository_item, ...",
        isMain: true
    },
    user: {
        id: "user",
        key: "",
        description: "Support customer, retailer, branch, branch_user, ...",
        isMain: true
    },
    branch: {
        id: "user",
        key: "",
        description: "Subset from user",
        isMain: false
    },
    logistic: {
        id: "logistic",
        key: "",
        description: "Support transporter, ...",
        isMain: true
    },
}

export const propTypes = {
    item: {
        product: {
            id: "product",
            key: "",
            target: targetTypes.item.id,
        },
        item: {
            id: "item",
            key: "",
            target: targetTypes.item.id,
        },
        category: {
            id: "category",
            key: "",
            target: targetTypes.item.id,
        }
    },
    document: {
        proformaSales: {
            id: "proforma_sales",
            key: "pso",
            target: targetTypes.document.id,
        },
        cashSales: {
            id: "cash_sales",
            key: "",
            target: targetTypes.document.id,
        },
        salesOrder: {
            id: "sales",
            key: "so",
            target: targetTypes.document.id,
        },
        salesInvoice: {
            id: "sales_invoice",
            key: "so",
            target: targetTypes.document.id,
        },
        deliveryOrder: {
            id: "delivery",
            key: "do",
            target: targetTypes.document.id,
        },
        itemReceive: {
            id: "item_receive",
            key: "do",
            target: targetTypes.document.id,
        },
        tripOrder: {
            id: "trip",
            key: "trip",
            target: targetTypes.document.id,
        },
    },
    documentItem: {
        proformaSales: {
            id: "proforma_sales",
            key: "pso",
            target: targetTypes.document.id,
        },
        cashSales: {
            id: "cash_sales",
            key: "",
            target: targetTypes.document.id,
        },
        salesOrder: {
            id: "sales",
            key: "so",
            target: targetTypes.document.id,
        },
        deliveryOrder: {
            id: "delivery",
            key: "do",
            target: targetTypes.document.id,
        },
        itemReceive: {
            id: "item_receive",
            key: "do",
            target: targetTypes.document.id,
        },
    },
    repository: {
        package: {
            id: "package",
            key: "",
            target: targetTypes.repository.id,
        },
        container: {
            id: "container",
            key: "",
            target: targetTypes.repository.id,
        },
    },
    user: {
        administrator: {
            id: "administrator",
            key: "",
            target: targetTypes.user.id,
        },
        supplier: {
            id: "supplier",
            key: "",
            target: targetTypes.user.id,
        },
        retailer: {
            id: "retailer",
            key: "",
            target: targetTypes.user.id,
        },
        customer: {
            id: "customer",
            key: "",
            target: targetTypes.user.id,
        },
        driver: {
            id: "driver",
            key: "",
            target: targetTypes.user.id,
        },
        worker: {
            id: "worker",
            key: "",
            target: targetTypes.user.id,
        },
    },
    branch: {
        customer: {
            id: "customer",
            key: "",
            target: targetTypes.user.id,
        },
        retailer: {
            id: "retailer",
            key: "",
            target: targetTypes.user.id,
        }
    },
    logistic: {
        transporter: {
            id: "transporter",
            key: "",
            target: targetTypes.logistic.id,
        },
    },
}

export const propRefs = {
    document: {
        id: "document",
        document: "document_id",
        proformaSales: "document_id",
        cashSales: "document_id",
        salesOrder: "document_id",
        salesInvoice: "document_id",
        deliveryOrder: "document_id",
        itemReceive: "document_id",
        tripOrder: "document_id",
    },
    documentItem: {
        id: "document_item",
        proformaSales: "document_item_id",
        cashSales: "document_item_id",
        salesOrder: "document_item_id",
        salesInvoice: "document_item_id",
        deliveryOrder: "document_item_id",
        itemReceive: "document_item_id",
    },
    item: {
        id: "item",
        product: "product_id",
        category: "category_id",
        item: "item_id",
    },
    repository: {
        id: "repository",
        package: "repository_id",
        container: "repository_id",
    },
    user: {
        id: "user",
        administrator: "user_id",
        supplier: "user_id",
        customer: "user_id",
        retailer: "user_id",
        driver: "user_id",
        worker: "user_id",
    },
    branch: {
        id: "branch",
        customer: "branch_id",
        retailer: "branch_id",
    },
    logistic: {
        id: "logistic",
        transporter: "logistic_id"
    }
}

export const propFieldTypes = {
    id: { id: "id", fieldName: "props_id" },
    text: { id: "text", fieldName: "props_text" },
    value: { id: "value", fieldName: "props_value" },
    numeric: { id: "numeric", fieldName: "props_numeric" },
    integer: { id: "integer", fieldName: "props_integer" },
    timestamp: { id: "timestamp", fieldName: "props_timestamp" },
    date: { id: "date", fieldName: "props_date" },
    date_time: { id: "date_time", fieldName: "props_date_time" },
}

// extract the scheduler ids from the response
export const getSchedulerRequestIds = (data) => {

    const resScheduler = data?.schedulers ? data.schedulers : []
    const schedulerRequestIds = resScheduler.map(i => i?.id)
    return schedulerRequestIds
}

// build and get the object for the create injection props payload
export const getAppendSchedulerProps = (ids, dataTypes = []) => {

    if (ids.length <= 0) return {}

    return {
        scheduler_request: {
            scheduler_request_ids: ids,
            data_types: dataTypes
        }
    }
}

export const getInjectionValueByPropName = ({ propType = '', targetType = '', propName, obj }) => {

    let fullPropName = ""

    // assume propName is the full prop name
    if (propType === "" && targetType === "") {
        fullPropName = propName
    } else { // using full prop  name
        fullPropName = getInjectionPropFullName({ propType, targetType, propName })
    }

    fullPropName = fullPropName.toLowerCase()

    if (fullPropName in obj) {
        return obj[fullPropName]
    }
    return ""
}

export const getInjectionPropFullName = ({ propType, targetType, propName }) => {

    let name = `${prefixInjectionProps}_${targetType}_${propType}_${propName}`
    return name.toLowerCase()
}

export function useInjectionProps({
    jwtToken: _jwtToken,
    propType: _propType,
    targetType: _targetType,
}) {

    const [propType, setPropType] = useState(_propType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient(_jwtToken);
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    // const endpoint1 = "injection_prop";
    const endpoint2 = "injection_props"

    const list = async (props) => {

        let {
            targetType: overrideTargetType
        } = props

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}/${targetType}`, props);

            if (overrideTargetType) {
                url = getListsUrl(`${endpoint2}/${overrideTargetType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({
        data,
        targetType: _targetType,
    }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint2}`;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ data, propType: overridePropType }) => {

        setIsLoading(true);

        if (data?.keys.length <= 0) {
            throw getError(false, `Please select at least (1) injection prop key`)
        }

        try {

            let url = `${endpoint2}/delete_key`

            // "keys": [
            //     "TESTA",
            //     "TESTB"
            // ],
            //     "ref_id": {
            //     "user_id": "3427"
            //     /* "branch_id" : "3397"
            //     // "repository_id": "398"
            //     // "product_id": "1015"
            //     // "item_id": "1015"
            //     // "document_id" : "1" */
            // }

            const postData = {
                scope: {
                    target: propType,
                    action: ""
                },
                payload: data
            }

            if (overridePropType) postData.scope.target = overridePropType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        propTypes,
        targetTypes,
        list,
        create,
        remove
    }
}